export const SELECTORS = {
  NATIVE: 'js-native-select-dropdown-v2',
  CUSTOM: 'js-custom-select-dropdown-v2',
  DROPDOWN: 'js-select-dropdown-v2',
  LABEL: 'js-select-dropdown-v2-label',
  SELECTED_OPTION: 'js-select-dropdown-v2-selected-option',
  OPTIONS: 'js-select-dropdown-v2-options',
  OPTION: 'js-select-dropdown-v2-option'
};
